import React, { FC } from 'react';
import styles from './Spinner.module.scss';
import { Colors } from '@/components/UI/Types';
import colors from '@/styles/_colors.module.scss';
type SpinnerProps = {
  size?: string;
  color: Colors | 'inherit';
};
const Spinner: FC<SpinnerProps> = ({
  size = '24px',
  color
}) => {
  const style = {
    width: size,
    height: size,
    border: `2px solid ${color === 'inherit' ? 'inherit' : colors[color]}`
  };
  return <div className={styles['spinner']} style={style} data-sentry-component="Spinner" data-sentry-source-file="Spinner.tsx"></div>;
};
export default Spinner;